module.exports = __webpack_public_path__ + "img/Misha.027995cc.jpg";